import { IStrandProduction } from "../../../types";
import { ReactElement } from "react";
import { getCurrentDatetimeInSeconds } from "../../../system/utils";
import KeyValueItem from "../../../components/charts/keyValueItem";

const StrandDetailInfo = (rmData: IStrandProduction): ReactElement => {
  let totalDelays = 0;
  rmData.delays.filter(xyz => !xyz.isDownDay).forEach(delay => {
    totalDelays += delay.duration ?? 0;
  });

  const barInMill = ((rmData.endDatetime ?? getCurrentDatetimeInSeconds()) - rmData.beginDatetime - totalDelays) / 60;

  return(
    <>
      <KeyValueItem name={"Bar in Mill"} value={barInMill.toFixed(1)} unit="min"/>
      <KeyValueItem name={"Heat Number"} value={`${rmData.heatNumber}`}/>
      <KeyValueItem name={"Steel"} value={rmData.steelCode}/>
    </>
  );
};

export default StrandDetailInfo;
